import keyBy from 'lodash/keyBy';

import Fields from '@/modules/corporate/modules/database/fields';
import { FieldType } from '@/modules/corporate/modules/database/interfaces';
import { DatabaseMetadataFieldType, DatabaseViewFieldType } from '@/types/schema';

interface Params {
  viewFields: DatabaseViewFieldType[];
  metadataFields: DatabaseMetadataFieldType[];
}

const getFields = ({ viewFields, metadataFields }: Params): FieldType[] => {
  const metadataFieldsById = keyBy(metadataFields, 'fieldId');

  return viewFields.reduce<FieldType[]>((accumulator, viewField, index) => {
    const metadataField = metadataFieldsById[viewField.fieldId];
    const config = Fields[metadataField?.type];

    if (metadataField && config) {
      const adaptedFields = config.adaptField
        ? config.adaptField({ metadataField, viewField })
        : { metadataField, viewField };

      accumulator.push({
        config,
        index,
        metadataField: adaptedFields.metadataField,
        viewField: adaptedFields.viewField,
      });
    }

    return accumulator;
  }, []);
};

export default getFields;
